import './card-style.css';
import { Link } from "react-router-dom";
import DOMPurify from 'dompurify';
import linesAmc from '../../assets/imgs/track/lines.svg';

function Card(props) {
  const convertTextUpper = props.btnMessage ? props.btnMessage.toUpperCase() : '';
  const imageSrc = DOMPurify.sanitize(props.image);
  const showLines = props.showLines !== false;
  const imageLinkTo = props.redirectHref;
  const imageIsClickable =
    typeof imageLinkTo === 'string' &&
    imageLinkTo.length > 0 &&
    imageLinkTo !== '#';
  const imageAriaLabel = props.title
    ? `Ir a ${props.title}`
    : 'Ir al servicio';

  const renderButton = () => {
    if(props.btnMessage !== undefined || props.redirectBtn !== undefined) {
      return (
        <a href={props.redirectBtn} target='_blank' rel='noreferrer' className="primary-btn">{convertTextUpper}</a>
      )
    }
  }

  const renderTitle = () => {
    if(props.icon !== undefined || props.title !== undefined) {
      return (
        <div className='text'>
          <i>
          {props.icon}
          </i>
          <h3>{[props.title]}</h3>
        </div>
      )
    } else {
      return (
        <>
          <img className='imgTitle' src={imageSrc} alt='AMC Internationals' />
        </>
      )
    }
  }

  return (
    <>
      <div className='targetContentCard'>
        <div className='imgContent'>
          {imageIsClickable ? (
            <Link
              to={imageLinkTo}
              className='imgContentLink'
              aria-label={imageAriaLabel}
              id={props.linkId ? `${props.linkId}-image` : undefined}
            >
              <img src={props.image} alt="" />
            </Link>
          ) : (
            <img src={props.image} alt={props.title || ''} />
          )}
        </div>
        <div className='titleCard'>
          {showLines && <img className='lines' src={linesAmc} alt='' aria-hidden='true' />}
          {renderTitle()}
        </div>

        <div className='textContetCard'>
          <p>
            {props.description}
          </p>
          
          <div className="actions">
            <Link to={props.redirectHref} id={props.linkId} className='redirecPageTo'>{props.redirect}</Link>
            <div>
              {renderButton()}
            </div>
          </div>
        </div>

      </div>

    </>
  );
}

export default Card;
